import React from "react";
const LogRocket = require("logrocket");
const setupLogRocketReact = require("logrocket-react");

import {
  checkServiceOpenRestaurant,
  fetchDataRestaurant,
} from "../services/actions/restaurant.actions";
import {
  fetchProductsInCart,
  createOrderAndUser,
  sendSessionPayPlus,
  fetchOrderData,
  createOrder,
} from "../services/actions/order.actions";
import { replaceUrl, isDesktop } from "./../utils/utils";
import { setRedirectPayPlus } from "../services/actions/website.actions";
import {
  checkingData,
  displayLoader,
} from "../services/actions/loader.actions";
import { initErrorPayment } from "../services/actions/error.actions";
import { getUserData } from "../services/actions/user.actions";
import "react-lazy-load-image-component/src/effects/blur.css";
import ErrorService from "./../components/user/ErrorService";
import ReactDetectOfflineAPI from "react-detect-offline-api";
import { Localized } from "fluent-react/compat";
import "react-phone-number-input/style.css";
import { wrapper } from "../store";

import "./../styles/userDesktop.scss";
import "./../styles/common.scss";
import "./../styles/user.scss";
import App from "next/app";

import Error from "./_error";
import { LocalizationProvider } from "fluent-react/compat";
import { fetcher } from "../services/sagas/fetcher.saga";
import { generateBundles } from "../languages/config";
import illuBurger from "./../img/svg/illuBurger.svg";
import Layout from "./../components/user/Layout";
import Schema from "./../components/user/Schema";
import Modal from "@material-ui/core/Modal";
import Loader from "react-loader-spinner";
import { connect } from "react-redux";
import { DefaultSeo } from "next-seo";
import Router from "next/router";
import { captureException } from "../utils/logRocket";

function parseMarkup(str) {
  return [
    {
      TEXT_NODE: 3,
      nodeType: 3,
      localName: undefined,
      textContent: str.toUpperCase(),
    },
  ];
}
class MyApp extends App {
  constructor(props) {
    super(props);
    this.state = {
      isInIframe: false,
      restaurant: {
        idMenuSelected: props.restaurant.idMenuSelected,
        address: props.restaurant.address,
        slogan: props.restaurant.slogan,
        phone: props.restaurant.phone,
        name: props.restaurant.name,
      },
      wrongUrl: props.router.pathname.includes("/_error"),
      paymentMethod: props.restaurant.paymentMethod,
      idRestaurant: props.idInitial,
      restaurantNotReady: false,
      errorMessageSecond: "",
      screenDesktop: null,
      onlineStatus: true,
      openService: true,
      errorMessage: "",
      dataMessage: "",
      stripe2: null,
      mobile: false,
      langsNav: [],
      loader: true,
      path: "",
      url: "",
      logRocket: props.logRocket,
    };
    this.removeOrderIdLocalStorage = this.removeOrderIdLocalStorage.bind(this);
    this.checkIfDataInLocalStorage = this.checkIfDataInLocalStorage.bind(this);
    this.updatePartLocalStorage = this.updatePartLocalStorage.bind(this);
    this.isRedirectFromPayPlus = this.isRedirectFromPayPlus.bind(this);
    this.removeServiceWorker = this.removeServiceWorker.bind(this);
    this.recoverIdRestaurant = this.recoverIdRestaurant.bind(this);
    this.redirectOrderStatus = this.redirectOrderStatus.bind(this);
    this.checkStatusPayment = this.checkStatusPayment.bind(this);
    this.checkAppVersions = this.checkAppVersions.bind(this);
    this.updateOrderUser = this.updateOrderUser.bind(this);
    this.fetchVariables = this.fetchVariables.bind(this);
    this.updateStorage = this.updateStorage.bind(this);
    this.updateLoader = this.updateLoader.bind(this);
    this.reloadPage = this.reloadPage.bind(this);
    this.activePath = this.activePath.bind(this);
    this.checkData = this.checkData.bind(this);
  }

  static getInitialProps = async ({ Component, ctx }) => {
    let idInitial = "";
    if (ctx.req && ctx.res.statusCode != "400" && ctx.query.idRestaurant) {
      const idRestaurant = ctx.query.idRestaurant.replace("#", "");
      const url = `${process.env.BACKEND_URL}/api/restaurant/get-id/${encodeURI(
        idRestaurant
      )}`;
      idInitial = await fetcher("GET", url, {}, "", true);
      if (idInitial && idInitial?.data?.success) {
        const dataInitial = await fetcher(
          "GET",
          `${process.env.BACKEND_URL}/api/restaurant/info/${idInitial.data.id}`,
          {},
          "",
          true
        );
        ctx.store.dispatch(fetchDataRestaurant(dataInitial.data));
      }
    }
    return {
      idInitial: idInitial && idInitial?.data?.success ? idInitial.data.id : null,
    };
  };

  async componentDidMount() {
    const { paymentMethod, idRestaurant } = this.state;
    if (idRestaurant) {

      this.checkIfDataInLocalStorage(
        idRestaurant,
        this.props.restaurant.menuWithProducts
      );
      this.props.checkServiceOpenRestaurant(idRestaurant);
      window.setInterval(() => {
        this.props.checkServiceOpenRestaurant(idRestaurant);
      }, 30000);
      this.setState({
        url: `${window.location.host}/commande-en-ligne/${idRestaurant}`,
      });
    } else {
      this.setState({
        wrongUrl: true,
        loader: false,
        errorMessage: "tr-url-wrong",
      });
    }
    if (window) {
      const config = await import("../config");
      const { type, token } = paymentMethod;
      this.removeOrderIdLocalStorage();
      let stripe = "";
      if (type === "stripe") {
        const { loadStripe } = await import("@stripe/stripe-js");
        stripe = loadStripe(config.default.keyPublicStripe, {
          stripeAccount: token,
        });
      }
      if (typeof window !== "undefined") {
        const userId = window.localStorage.getItem("USER_ID");
        const orderId = window.sessionStorage.getItem("ORDER_ID")
        if (this.state.logRocket) {
          LogRocket.init("q2xmea/commande-en-ligne");
          LogRocket.identify(idRestaurant, { name: this.state.restaurant.name, orderId: orderId, userId: userId })
          setupLogRocketReact(LogRocket);
        }
      }
      this.activePath(Router.asPath);
      this.removeServiceWorker();
      this.setState({
        isInIframe: window.location != window.parent.location,
        langsNav: navigator.languages,
        screenDesktop: isDesktop(window),
        //TODO CHECK WITH PAY+
        stripe2: stripe,
      });
    }
  }

  componentDidUpdate() {
    if (this.props.refreshApp && !this.state.path) {
      this.reloadPage();
    }
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    this.activePath(Router.asPath);
    const { path, paymentMethod, openService } = this.state;
    const { errorPayment } = nextProps;
    const moduleDisabled = ["tr-module-disabled", "tr-payment-unavailable"].includes(nextProps.restaurant.messageService);
    if (openService !== nextProps.restaurant.serviceOpen) {
      this.setState({
        errorMessage: nextProps.restaurant.messageService,
        openService: nextProps.restaurant.serviceOpen,
        dataMessage: nextProps.restaurant.dataMessage,
        restaurantNotReady: moduleDisabled,
      });
    }
    if (
      paymentMethod.type === "none" ||
      !nextProps.restaurant.menuWithProducts ||
      (paymentMethod.type !== "none" && !nextProps.restaurant.menuWithProducts)
    ) {
      this.setState({
        restaurantNotReady: true,
        errorMessage: "restaurant-not-ready",
      });
    }
    /*************/
    /*************/
    /*************/
    if (
      this.props.dataChecked !== nextProps.dataChecked ||
      (path === "status-livraison" && this.props.refreshApp)
    ) {
      this.updateLoader();
    }

    if (
      path !== "panier" &&
      errorPayment.error &&
      errorPayment.declineCode === "error-cart"
    ) {
      this.props.initErrorPayment();
    }
  }

  removeOrderIdLocalStorage() {
    const storageOrder = window.localStorage.getItem("ORDER_ID");
    if (storageOrder) window.localStorage.removeItem("ORDER_ID");
  }

  async checkIfDataInLocalStorage(idRestaurant, hasMenu) {
    const storageOrder = window.sessionStorage.getItem("ORDER_ID");
    const storageUser = window.localStorage.getItem("USER_ID");
    const { idMenuSelected } = this.state.restaurant;
    if (hasMenu) {
      if (!storageOrder && !storageUser) {
        this.updateOrderUser("createOrderUser", idRestaurant, storageUser);
      }
      if (!storageOrder && storageUser) {
        const findUser = await fetcher("GET", `user/find/${storageUser}`);
        if (findUser.data.success) {
          this.updateOrderUser("createOrderGet", idRestaurant, storageUser);
        } else {
          this.updatePartLocalStorage("remove", "user");
          this.updateOrderUser("createOrderUser", idRestaurant, storageUser);
        }
      }
      if (storageOrder && storageUser) {
        const findUser = await fetcher("GET", `user/find/${storageUser}`);
        if (findUser.data.success) {
          const resultIdMenuOrder = await fetcher(
            "GET",
            `order/${storageOrder}`
          );
          if (
            !resultIdMenuOrder.data.success ||
            resultIdMenuOrder.data.idMenuOrder != idMenuSelected
          ) {
            this.updatePartLocalStorage("remove", "order");
            this.updateOrderUser("createOrderGet", idRestaurant, storageUser);
            return;
          }
          const isRedirectPayPlus = this.isRedirectFromPayPlus();
          const selectStatusPayment = await fetcher(
            "GET",
            `order/status-payment/${storageOrder}/${idRestaurant}`
          );
          if (isRedirectPayPlus) {
            this.props.displayLoader();
            this.props.checkingData();
            this.props.sendSessionPayPlus(selectStatusPayment.data.value);
            this.props.setRedirectPayPlus(true);
            this.props.fetchProductsInCart(storageOrder, idRestaurant);
            this.props.getUserData(storageUser);
            this.props.fetchOrderData(storageOrder, idRestaurant);
            return;
          } else {
            const paymentStatus = selectStatusPayment.data.status;
            this.checkStatusPayment(
              idRestaurant,
              paymentStatus,
              storageOrder,
              storageUser
            );
          }
        } else {
          this.updatePartLocalStorage("remove", "orderUser");
          this.updateOrderUser("createOrderUser", idRestaurant, storageUser);
        }
      }
    }
    this.props.checkingData();
  }

  updatePartLocalStorage(action, type) {
    switch (type) {
      case "orderPay+":
        window.localStorage.removeItem("COMMENT");
        window.localStorage.removeItem("TIME_TAKE_AWAY");
        break;
      case "orderUser":
        window.localStorage.removeItem("ORDER_ID");
        window.localStorage.removeItem("USER_ID");
        break;
      case "order":
        window.localStorage.removeItem("ORDER_ID");
        break;
      case "user":
        window.localStorage.removeItem("USER_ID");
        break;
    }
  }

  isRedirectFromPayPlus() {
    const urlParams = window.location.search;
    if (urlParams) {
      const isRedirect = urlParams.includes("redirectFromPayment");
      if (isRedirect) {
        replaceUrl();
        return true;
      }
      return false;
    }
    return false;
  }

  removeServiceWorker() {
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", function() {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          if (registrations.length) {
            for (let registration of registrations) {
              registration.unregister().then((bool) => {
                console.log("unregister: ", bool);
              });
            }
            window.location.reload();
          }
        });
      });
    }
  }

  updateLoader() {
    this.setState({ loader: !this.state.loader });
  }

  checkAppVersions(variables) {
    const getServerVersion = window.localStorage.getItem("serverVersion");
    const getFrontVersion = window.localStorage.getItem("frontVersion");
    const result = this.checkData(getServerVersion, getFrontVersion, variables);
    if (result.toUpdate) {
      const getUserId = window.localStorage.getItem("USER_ID");
      this.updateStorage(result.serverVersion, result.frontVersion, getUserId);
      //this.reloadPage();
    }
  }

  updateOrderUser(actionToDo, idRestaurant, idUser) {
    this.props.checkingData();
    switch (actionToDo) {
      case "createOrderGet":
        this.props.createOrder(idRestaurant, idUser);
        this.props.getUserData(idUser);
        break;
      case "createOrderUser":
        this.props.createOrderAndUser(idRestaurant);
        break;
      case "deleteOrderCreate":
        window.localStorage.removeItem("ORDER_ID");
        this.props.createOrder(idRestaurant, idUser);
        this.props.getUserData(idUser);
        break;
      default:
        return;
    }
  }

  async fetchVariables() {
    const result = await fetcher("GET", `variables`);
    const { variables } = result.data;
    return variables;
  }

  updateStorage(newServerVersion, newFrontVersion, getUserId) {
    window.localStorage.clear();
    window.sessionStorage.clear();
    window.localStorage.setItem("serverVersion", newServerVersion);
    window.localStorage.setItem("frontVersion", newFrontVersion);
    //return getUserId ? window.localStorage.setItem("USER_ID", getUserId) : null;
  }

  async recoverIdRestaurant() {
    const { idRestaurant } = this.state;
    const result = await fetcher("GET", `restaurant/get-id/${idRestaurant}`);
    if (result.data.success) {
      return result.data.id;
    } else {
      return null;
    }
  }

  redirectOrderStatus(orderId) {
    Router.push(
      "/commande-en-ligne/[idRestaurant]/status-livraison/[idOrder]",
      `/commande-en-ligne/${Router.query.idRestaurant}/status-livraison/${orderId}`
    );
  }

  checkStatusPayment(idRestaurant, paymentStatus, idOrder, idUser) {
    switch (paymentStatus) {
      case "requires_payment_method":
      case "progress":
        this.props.checkingData();
        this.props.fetchProductsInCart(idOrder, idRestaurant);
        this.props.getUserData(idUser);
        this.props.fetchOrderData(idOrder, idRestaurant);
        break;
      default:
        this.updateOrderUser("deleteOrderCreate", idRestaurant, idUser);
    }
  }

  reloadPage() {
    window.location.reload();
  }

  checkData(storageServerVersion, storageFrontVersion, variables) {
    return variables.reduce(
      (acc, data) => {
        switch (data.key_) {
          case "serverVersion":
            const updateServer = check(data, storageServerVersion);
            if (updateServer) {
              acc = { ...acc, toUpdate: true, [data.key_]: data.value };
            }
            break;
          case "frontVersion":
            const updateFront = check(data, storageFrontVersion);
            if (updateFront) {
              acc = { ...acc, toUpdate: true, [data.key_]: data.value };
            }
            break;
          default:
            return acc;
        }
        return acc;
      },
      {
        toUpdate: false,
        serverVersion: storageServerVersion,
        frontVersion: storageFrontVersion,
      }
    );
    function check(data, dataToCompare) {
      const { value } = data;
      return value !== dataToCompare;
    }
  }

  activePath(url) {
    const splitPath = url.split("/");
    const path = splitPath.length < 4 ? "" : splitPath[3];
    const newPath = path.replace("#", "");
    if (url.includes("#")) {
      if (this.state.idRestaurant) {
        const idRestaurant = Router.query.idRestaurant.replace("#", "");
        Router.push(
          `/commande-en-ligne/[idRestaurant]/${newPath}`,
          `/commande-en-ligne/${idRestaurant}/${newPath}`,
          { shallow: true }
        );
      } else {
        this.setState({
          wrongUrl: true,
          loader: false,
          errorMessage: "tr-url-wrong",
        });
      }
    }
    this.setState({ path: newPath });
  }

  render() {
    const { Component, restaurant } = this.props;
    const {
      restaurantNotReady,
      errorMessageSecond,
      screenDesktop,
      errorMessage,
      onlineStatus,
      idRestaurant,
      dataMessage,
      openService,
      isInIframe,
      wrongUrl,
      langsNav,
      stripe2,
      loader,
      path,
      url,
    } = this.state;
    const container =
      path.includes("status-livraison") && !screenDesktop ?
        "container-with-header-in-order-resume" :
        path ?
          "container-with-navHeader" :
          "container-with-header";
    if (loader) {
      return (
        <div id="loader" className="main-loader">
          <Loader type="ThreeDots" color="#e84249" height={45} width={45} />
        </div>
      );
    } else {
      return (
        <React.Fragment>
          <ReactDetectOfflineAPI
            apiUrl={"/api/ping2"}
            checkInterval={
              typeof window !== "undefined" &&
                window.location.hostname === "localhost"
                ? 50000
                : 300000
            }
            onOnline={() => {
              this.setState({ onlineStatus: true });
            }}
            onOffline={(error) => {
              captureException(error, {
                extra: {
                  "restaurant_id": idRestaurant,
                }
              })
              this.setState({ onlineStatus: false });
            }}
            initialStatusCallback={(status) => {
              this.setState({ onlineStatus: status ? true : false });
            }}
            resolveOnlineStatusFromPromise={(response) => {
              return response.status == 200;
            }}
          />
          <LocalizationProvider
            bundles={generateBundles(langsNav)}
            parseMarkup={parseMarkup}
          >
            {wrongUrl ? (
              <Error statusCode={404} title={errorMessage} />
            ) : (
              <React.Fragment>
                <DefaultSeo
                  title={`commande en ligne ${restaurant.name}`}
                  description={`${restaurant.slogan}`}
                  openGraph={{
                    url,
                    title: `commande en ligne ${restaurant.name}`,
                    description: `${restaurant.slogan}`,
                    site_name: `commande en ligne ${restaurant.name}`,
                  }}
                />
                <Schema
                  openingDate={restaurant.openingDate}
                  address={restaurant.address}
                  menu={restaurant.menu}
                  name={restaurant.name}
                  slogan={restaurant.slogan}
                  phone={restaurant.phone}
                />
                <Layout
                  restaurantNotReady={restaurantNotReady}
                  screenDesktop={screenDesktop}
                  idRestaurant={idRestaurant}
                  onlineStatus={onlineStatus}
                  slogan={restaurant.slogan}
                  openService={openService}
                  isInIframe={isInIframe}
                  name={restaurant.name}
                  path={path}
                >
                  {onlineStatus ? (
                    !restaurantNotReady ? (
                      <div
                        className={`content container is-centered ${container}`}
                      >
                        <Component
                          screenDesktop={screenDesktop}
                          idRestaurant={idRestaurant}
                          stripe2={stripe2}
                        />
                      </div>
                    ) : (
                      <div
                        className={`content container is-centered container-with-navHeader`}
                      >
                        <ErrorService
                          errorMessageSecond={errorMessageSecond}
                          errorMessage={errorMessage}
                          displayButtonReload={false}
                          dataMessage={dataMessage}
                        />
                      </div>
                    )
                  ) : (
                    <Modal open={true} className="container-server-down">
                      <div className="container-img-text">
                        <img src={illuBurger} alt="image burger" />
                        <div className="container-text-server-down">
                          <h1>
                            <Localized id="tr-error-serveur-title" />
                          </h1>
                          <p>
                            <Localized id="tr-error-serveur-message" />
                          </p>
                        </div>
                      </div>
                    </Modal>
                  )}
                </Layout>
              </React.Fragment>
            )}
          </LocalizationProvider>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = (state) => {
  const { restaurant, website, loader, error } = state;
  return {
    restaurant: restaurant.infoRestaurant,
    dataChecked: loader.checkingData,
    errorPayment: error.errorPayment,
    refreshApp: website.refreshApp,
    logRocket: restaurant.logRocket,
  };
};

const actionCreators = {
  checkServiceOpenRestaurant,
  fetchProductsInCart,
  sendSessionPayPlus,
  createOrderAndUser,
  setRedirectPayPlus,
  initErrorPayment,
  fetchOrderData,
  displayLoader,
  checkingData,
  createOrder,
  getUserData,
};

export default wrapper.withRedux(
  connect(mapStateToProps, actionCreators)(MyApp)
);
